import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TripleShade = () => {
   const whatWeOfferRef = useRef(null); 
            
              const scrollToSection = () => {
                if (whatWeOfferRef.current) {
                  whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
                }
              };
  const features = [
    {
      title: "Light Control",
      description:
        "Easily adjust light levels with Triple Shades Blinds for perfect ambiance and privacy.",
    },
    {
      title: "Timeless Design",
      description:
        "Elegant Triple Shades Blinds bring a natural warmth to your home, complementing any decor style.",
    },
    {
      title: "Durability",
      description:
        "Made from high-quality materials, ensuring long-lasting beauty and performance.",
    },
    {
      title: "UV Protection",
      description:
        "Block harmful UV rays while still allowing natural light into your space.",
    },
    {
      title: "Energy Efficiency",
      description:
        "Triple Shades Blinds help improve insulation and reduce energy costs, keeping your home comfortable.",
    },
    {
      title: "Custom Fit",
      description:
        "Tailored to your window dimensions, ensuring a perfect fit for any room.",
    },
  ];
  
  const [activeIndex, setActiveIndex] = useState(null);
  
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  
  return (
    <div className='font-playfair'>
      
<section 
   className="object-cover h-screen bg-cover bg-center flex flex-col  items-center  pt-40 md:pt-32 "
   style={{ backgroundImage: "url('images/triple2.jpg')" }}
 >
  <div className=" text-center lg:px-24">
    <h1 className="text-6xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl">
    Triple Shades
    </h1>
    <h1 className="text-6xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl ">
      Blinds
    </h1>
  </div>

  {/* Button positioned below the text */}
  <div className="mt-4 2xl:mt-6 flex justify-center  ">
    <button onClick={scrollToSection} className="text-black bg-[#fff] 2xltext-xl w-40 2xl:w-48 px-6 py-2">
      LEARN MORE
    </button>
  </div>
</section>

      <div className="flex flex-col xl:gap-20  xl:px-20">
        {/* Header Section */}
        <header className="text-center pt-20">
          <h1 ref={whatWeOfferRef} className="text-4xl md:text-5xl lg:text-8xl font-extrabold text-gray-900 mb-8 ">Triple Shades Blinds</h1>
        </header>

        {/* About Triple Shades Blinds */}
        <section className="mb-16 px-3 flex  flex-col lg:flex-row gap-6 xl:gap-20 justify-between items-center">
          <h2 className="text-2xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800  text-center">What are Triple Shades Blinds?</h2>
          <p className=" text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
          Triple Shades Blinds are elegant window treatments that offer both aesthetic appeal and functionality.
           They provide privacy, light control, and a cozy atmosphere in any room, combining natural materials
            with modern design.
          </p>
        </section>

        {/* Benefits of Triple Shades Blinds */}
        <section className="mb-16 px-3 flex flex-col lg:flex-row gap-10 md:gap-20 justify-between items-center">
          {/* < className=" text-xl text-gray-700"> */}
            <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
            Triple Shades Blinds provide a practical solution for controlling light, privacy, and energy efficiency.
             Their versatility adds elegance to any room while offering easy maintenance and long-term durability.

            </p>

          <h2 className="text-4xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 text-center">Benefits of Triple Shades Blinds</h2>

        </section>

        {/* How Triple Shades Blinds Work */}
        <section className="xl:mb-16 px-3 flex flex-col lg:flex-row gap-5 xl:gap-20 justify-between items-center">
          <h2 className="text-3xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 mb-4 text-center">How Do  Triple Shades Blinds Work?</h2>
          <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify ">
          Triple Shades Blinds function by tilting the slats to adjust the light entering the room, providing flexibility for creating the perfect ambiance. Whether for complete darkness or a gentle flow of natural light, Triple Shades Blinds are the ideal choice.
          </p>
        </section>
        </div>

    {/* Content Section */}
  <section className="py-16 px-2 md:px-6">
  <h2 className="text-3xl md:text-5xl lg:text-7xl font-bold text-center mb-10 md:mb-20 ">
  Transform Your Space with Triple Shades Blinds
  </h2>
  <div className="flex flex-col gap-20 xl:gap-40">
    {/* Benefit 1 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-arround">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8">Effortless Morning Comfort</h3>
        <p className="text-gray-600 text-xl  md:text-2xl xl:text-4xl text-justify">
        Start your day with the natural beauty of Triple Shades Blinds, gradually letting in light to create 
        a gentle sunrise effect. Perfect for waking up refreshed and energized, with a comfortable and
         soothing atmosphere.

        </p>
      </div>
      <div className="w-full ">
        <img
         className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/triple2.jpg"
          alt="Effortless Morning Comfort"
        />
      </div>
    </div>

    {/* Benefit 2 */}
    <div className="flex flex-col lg:flex-row-reverse gap-20 md:gap-5 items-center justify-between">
      <div className="w-full  max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Customized Comfort Throughout the Day</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Triple Shades Blinds offer control over your environment, whether you need sunlight or a dimmed, cozy atmosphere.
         Adjust them easily to suit your needs, whether for work, relaxation, or entertainment.

        </p>
      </div>
      <div className="w-full ">
        <img
         className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/triple1.jpg"
          alt="Customized Comfort Throughout the Day"
        />
      </div>
    </div>

    {/* Benefit 3 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-between">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Transform Your Space with Triple Shades Blinds
        </h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Set the mood for your evening with Triple Shades Blinds. Adjust them to achieve the 
        perfect level of privacy and light, creating a relaxed and elegant atmosphere for any gathering
         or quiet night in.

        </p>
      </div>
      <div className="w-full ">
        <img
           className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/triple.jpg"
          alt="Evening Elegance"
        />
      </div>
    </div>
  </div>
</section>

      {/* Features */}
      <section className="mb-16 bg-white p-8 max-w-6xl mx-auto xl:pt-20">
        <h2 className="text-3xl md:text-6xl text-center font-semibold text-gray-800 mb-20">
          Key Features of Triple Shades Blinds
        </h2>
        <div>
          {features.map((feature, index) => (
            <div
              key={index}
              className="border-b border-gray-400 p-3 mb-4 "
            >
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-xl md:text-4xl font-semibold text-gray-800 mb-6">
                  {feature.title}
                </h3>
                <button
                  className="text-xl md:text-4xl font-bold text-gray-600"
                  aria-label="Toggle FAQ"
                >
                  {activeIndex === index ? "-" : "+"}
                </button>
              </div>
              {activeIndex === index && (
                <p className="text-gray-600 mt-2 text-base md:text-3xl">{feature.description}</p>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default TripleShade;

// import React, { useEffect, useRef } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// gsap.registerPlugin(ScrollTrigger);

// const TripleShade = () => {
//   const sectionRef = useRef(null);

//   useEffect(() => {
//     const ctx = gsap.context(() => {
//       gsap.from('.triple-shade-content', {
//         scrollTrigger: {
//           trigger: '.triple-shade-content',
//           start: 'top center+=100',
//           toggleActions: 'play none none reverse'
//         },
//         y: 60,
//         opacity: 0,
//         duration: 1,
//         stagger: 0.3
//       });

//       gsap.from('.showcase-item', {
//         scrollTrigger: {
//           trigger: '.showcase-grid',
//           start: 'top center+=100',
//           toggleActions: 'play none none reverse'
//         },
//         scale: 0.9,
//         opacity: 0,
//         duration: 0.8,
//         stagger: 0.2
//       });
//     }, sectionRef);

//     return () => ctx.revert();
//   }, []);

//   return (
//     <section ref={sectionRef} className="py-20 bg-gradient-to-br from-indigo-50 via-white to-purple-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-16">
//           <h2 className="text-4xl font-bold text-indigo-900 mb-4">Triple Shade Blinds</h2>
//           <p className="text-xl text-indigo-600 max-w-2xl mx-auto">
//             Experience ultimate light control with our innovative triple-layer technology
//           </p>
//         </div>

//         <div className="triple-shade-content relative mb-24">
//           <div className="grid md:grid-cols-2 gap-8">
//             <div className="relative">
//               <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl">
//                 <img
//                   src="https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
//                   alt="Triple Shade Showcase"
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="absolute -bottom-8 left-8 right-8 bg-white p-6 rounded-xl shadow-xl">
//                 <div className="flex justify-between items-center">
//                   <div>
//                     <h3 className="text-xl font-bold text-indigo-900">Premium Collection</h3>
//                     <p className="text-indigo-600">Starting from $299</p>
//                   </div>
//                   <button className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 transition-colors">
//                     Learn More
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="space-y-6">
//               <div className="bg-white p-8 rounded-xl shadow-lg">
//                 <h3 className="text-2xl font-bold text-indigo-900 mb-4">Three-Layer Innovation</h3>
//                 <p className="text-gray-600 mb-6">
//                   Our triple-layer design combines sheer, semi-opaque, and blackout fabrics for unparalleled versatility
//                 </p>
//                 <div className="grid grid-cols-3 gap-4">
//                   <img
//                     src="https://images.unsplash.com/photo-1513694203232-719a280e022f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                     alt="Layer 1"
//                     className="w-full aspect-square object-cover rounded-lg"
//                   />
//                   <img
//                     src="https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                     alt="Layer 2"
//                     className="w-full aspect-square object-cover rounded-lg"
//                   />
//                   <img
//                     src="https://images.unsplash.com/photo-1484154218962-a197022b5858?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                     alt="Layer 3"
//                     className="w-full aspect-square object-cover rounded-lg"
//                   />
//                 </div>
//               </div>

//               <div className="grid grid-cols-2 gap-6">
//                 <div className="bg-white p-6 rounded-xl shadow-lg">
//                   <img
//                     src="https://images.unsplash.com/photo-1513694203232-719a280e022f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                     alt="Day Mode"
//                     className="w-full aspect-video object-cover rounded-lg mb-4"
//                   />
//                   <h4 className="text-lg font-semibold text-indigo-900">Day Mode</h4>
//                   <p className="text-sm text-gray-600">Perfect natural light</p>
//                 </div>
//                 <div className="bg-white p-6 rounded-xl shadow-lg">
//                   <img
//                     src="https://images.unsplash.com/photo-1513519245088-0e12902e35a0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
//                     alt="Night Mode"
//                     className="w-full aspect-video object-cover rounded-lg mb-4"
//                   />
//                   <h4 className="text-lg font-semibold text-indigo-900">Night Mode</h4>
//                   <p className="text-sm text-gray-600">Complete privacy</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="showcase-grid grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
//           {['Classic White', 'Warm Gray', 'Soft Beige'].map((style, index) => (
//             <div key={style} className="showcase-item group relative">
//               <div className="aspect-[4/3] rounded-xl overflow-hidden shadow-lg mb-4">
//                 <img
//                   src={`https://images.unsplash.com/photo-${index === 0 ? '1513519245088-0e12902e35a0' : index === 1 ? '1484154218962-a197022b5858' : '1513694203232-719a280e022f'}?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80`}
//                   alt={style}
//                   className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
//                   <div className="text-white">
//                     <h4 className="text-lg font-semibold">{style}</h4>
//                     <p className="text-sm opacity-90">Perfect for modern interiors</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//           {[1, 2, 3, 4].map((item) => (
//             <div key={item} className="showcase-item relative aspect-square rounded-lg overflow-hidden shadow-lg">
//               <img
//                 src={`https://images.unsplash.com/photo-${item % 2 === 0 ? '1513519245088-0e12902e35a0' : '1484154218962-a197022b5858'}?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80`}
//                 alt={`Gallery ${item}`}
//                 className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default TripleShade;